import { render, staticRenderFns } from "./BankDocByInvoices.vue?vue&type=template&id=558d645a&scoped=true&"
import script from "./BankDocByInvoices.vue?vue&type=script&lang=ts&"
export * from "./BankDocByInvoices.vue?vue&type=script&lang=ts&"
import style0 from "./BankDocByInvoices.vue?vue&type=style&index=0&id=558d645a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558d645a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCard,VCardText,VCardTitle,VProgressCircular,VSpacer,VSwitch})
